// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1edbF","colMin":"styles_colMin__a4Rvo"};